
import { Vue, Component, Prop } from 'vue-property-decorator'
import { some, every, isSome, filter } from '@/utils/arrays'
import { PermissionModule } from '@/store/modules/permission'
import { setMerchantManagerAuth } from '@/api/merchant/manager'

@Component({
  name: 'auth',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) menuAuthList!: any[]
  @Prop({ required: true }) permission!: any[]
  @Prop({ required: true }) adminId!: number
  @Prop({ required: true }) isAdmin!: boolean

  private loading: boolean = true
  private moduleList: any[] = []
  private menuList: any[] = []
  private isIndeterminate: boolean[] = []
  private isIndeterminateMenuList: boolean[] = []
  private fnList: any[] = this.permission
  mounted () {
    this.initAuth()
  }

  private async save () {
    await setMerchantManagerAuth({
      manager_id: this.adminId,
      permission_ids: this.fnList
    }).then(() => {
      this.$message({
        message: 'Authorization success',
        type: 'success'
      })
    })
  }

  // 更改模块选中状态
  private setModule (moduleId: number, menus: any[]) {
    // 下属功能权限列表
    let funcs: any[] = []
    // 下属子菜单id列表
    const menuIds: number[] = []
    // 遍历下属子菜单
    menus.forEach(menu => {
      // 若子菜单含有权限，将菜单和权限保存
      if (menu.permission) {
        menuIds.push(menu.id)
        funcs = funcs.concat(menu.permission)
      }
    })

    // 获取权限ID列表
    const funcIds = funcs.map((p: any) => p.id)
    // 判断操作的模块是否在模块列表中
    if (!this.moduleList.includes(moduleId)) {
      // 若不在，则过滤
      this.menuList = filter(menuIds, this.menuList)
      this.fnList = filter(funcIds, this.fnList)
    } else {
      // 若在，则合并
      this.menuList = this.menuList.concat(menuIds)
      this.fnList = this.fnList.concat(funcIds)
    }

    // 将模块设置成未全选中
    this.isIndeterminate[moduleId] = false
    // 将菜单设置成未选中
    menuIds.forEach(menuId => {
      this.isIndeterminateMenuList[menuId] = false
    })
  }

  // 更改菜单选中状态
  private setMenu (moduleId: number, menu: any, menus: any[]) {
    const { id, permission } = menu
    if (permission) {
      // 子菜单含有权限列表
      // 获取权限id列表
      const funcIds = permission.map((p: any) => p.id)

      // 获取需要操作的权限列表
      if (!this.menuList.includes(id)) {
        this.fnList = filter(funcIds, this.fnList)
      } else {
        this.fnList = this.fnList.concat(funcIds)
      }

      // 将菜单状态更改为全选或未选中状态
      this.isIndeterminateMenuList[id] = false
    }
    this.setAllMenu(moduleId, menus)
  }

  // 是否全选中某模块下的所有子菜单
  private setAllMenu (moduleId: number, menus: any[]) {
    const menuIds = menus.map((menu: any) => menu.id)

    const isAllFunc = every(this.menuList, menuIds)
    const isFunc = some(this.menuList, menuIds)
    const isAllSubs = isSome(this.isIndeterminateMenuList, menuIds)
    if (isAllFunc) {
      this.moduleList.push(moduleId)
      this.isIndeterminate[moduleId] = false
    } else if (isFunc && isAllSubs) {
      this.isIndeterminate[moduleId] = true
    } else if (!isFunc) {
      this.isIndeterminate[moduleId] = false
      this.moduleList = this.moduleList.filter((mo: any) => {
        return mo !== moduleId
      })
    }
  }

  // 更改权限功能选中状态
  private setFn (moduleId: number, menu: any, menus: any[]) {
    const { id, permission } = menu
    const funcIds = permission.map((p: any) => p.id)
    // 选中所有
    const isAllFunc = every(this.fnList, funcIds)
    // 选中部分
    const isFunc = some(this.fnList, funcIds)
    // 获取当前操作节点的菜单
    const checkMenus = this.menuList.filter(m => {
      return m !== id
    })

    if (isAllFunc) {
      // 选中所有
      this.menuList.push(id)
      // 更改子菜单状态为全选或未全选
      this.isIndeterminateMenuList[id] = false
      this.setAllMenu(moduleId, menus)
    } else if (!isAllFunc && isFunc) {
      // 只选中部分
      // // 更改子菜单和模块状态为选中部分
      this.isIndeterminateMenuList[id] = true
      this.menuList = checkMenus
      this.isIndeterminate[moduleId] = true
    } else {
      // 都未选
      this.isIndeterminateMenuList[id] = false
      this.menuList = checkMenus
      this.setAllMenu(moduleId, menus)
    }
  }

  // 过滤多余功能权限
  private filterFuncs (funcs: any[]) {
    let funcList: any[] = []
    // 遍历菜单权限列表
    this.menuAuthList.forEach((mo: any) => {
      // 遍历子菜单列表
      mo.children.forEach((menu: any) => {
        if (menu.permission) {
          // 权限存在
          // 获取权限id列表，合并
          const funcsIdList = menu.permission.map((p: any) => p.id)
          funcList = funcList.concat(funcsIdList)
        }
      })
    })

    // 过滤
    const filterfuncs = funcs.filter(val => {
      return funcList.includes(val)
    })

    return filterfuncs
  }

  // 初始化选中状态
  private initAuth () {
    this.loading = true
    this.moduleList = []
    this.menuList = []
    this.isIndeterminate = []
    this.isIndeterminateMenuList = []

    // 遍历菜单权限列表
    this.menuAuthList.forEach(mo => {
      const meduleId = mo.id // 获取模块id，父菜单id
      const menuIds: number[] = []
      let isAllFunc = false // 是否包含所有功能
      let isFunc = false
      mo.children.shift()
      // 遍历子菜单
      mo.children.forEach((menu: any) => {
        // 子菜单是否含有权限
        if (menu.permission && menu.permission.length > 0) {
          this.fnList = this.filterFuncs(this.fnList)
          const menuId = menu.id // 获取子菜单id
          menuIds.push(menuId)
          // 获取权限id列表
          const funcIds = menu.permission.map((p: any) => p.id)

          if (funcIds.length > 0) {
            // 权限列表是否包含funcIds所有元素
            isAllFunc = every(this.fnList, funcIds)
            // 权限列表是否包含funcIds任意元素
            isFunc = some(this.fnList, funcIds)
          }

          if (isAllFunc) {
            // 权限列表包含funcIds所有元素
            // 将菜单id追加到菜单列表，设置菜单全选中状态或为全选状态
            this.menuList.push(menuId)
            this.isIndeterminateMenuList[menuId] = false
          } else if (!isAllFunc && isFunc) {
            // 权限列表仅包含funcIds部分元素
            // 设置菜单状态为选中部分
            this.isIndeterminateMenuList[menuId] = true
          }
        }
      })

      // 菜单列表是否包含menuIds所有元素
      const isAllMenu = every(this.menuList, menuIds)
      // 菜单列表是否包含menuIds包含的元素或不含有
      const isAllAuth = isSome(this.isIndeterminateMenuList, menuIds)
      if (isAllMenu) {
        // 菜单列表包含了menuIds所有元素
        // 将模块id追加到模块列表，设置模块未全选中状态
        this.moduleList.push(meduleId)
        this.isIndeterminate[meduleId] = false
      } else if (isAllAuth) {
        // 设置模块全选中状态
        this.isIndeterminate[meduleId] = true
      }
    })
    this.loading = false
  }
}
